import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/root/styles.scss';export default {
  "root": "_root_1xu1k_1",
  "dragged": "_dragged_1xu1k_6"
};